import { Stack, SxProps, Typography, useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { UserRoleEnum } from '~enums';
import { getUserRoleLabel } from '~enums/userRoleEnum';
import { BaseReference } from '~interfaces';
import { Dimens } from '~themes';

import Dropdown from './dropdown';

interface Props {
	selectedValue?: string;
	selectableRoles: UserRoleEnum[];
	onValueChanged: (newValue?: UserRoleEnum) => void;
	disableClearable?: boolean;
	required?: boolean;
	label?: string;
	placeholder?: string;
	sx?: SxProps;
}

const SimpleRolesDropDown = ({
	selectedValue,
	selectableRoles,
	label,
	sx,
	placeholder,
	disableClearable = true,
	required = false,
	...props
}: Props) => {
	const { t } = useTranslation();
	const { palette } = useTheme();

	// Data
	const allRoles = selectableRoles.sort().map(
		(role) =>
			({
				id: role as string,
				name: getUserRoleLabel(role, t),
			}) as BaseReference
	);

	const handleOptionSelected = (value: BaseReference | null) => {
		props.onValueChanged(value?.id as UserRoleEnum);
	};

	// Component
	return (
		<Stack sx={{ gap: Dimens.spacingXs }}>
			{label && (
				<Typography variant='labelSm' color={palette.textPrimary.main}>
					{label}
					{required && (
						<Typography variant='labelSm' color={palette.textBrandTertiary.main} component='span'>
							*
						</Typography>
					)}
				</Typography>
			)}
			<Dropdown
				value={selectedValue ? allRoles.find((value) => value.id == selectedValue) : undefined}
				values={allRoles}
				sx={sx}
				canClear={!disableClearable}
				onValueChanged={handleOptionSelected}
				placeholder={placeholder}
			/>
		</Stack>
	);
};

export default SimpleRolesDropDown;
